var map = {
	"./DSC_0059-1024x683.jpg": 3651,
	"./DSC_0061-1024x683.jpg": 33,
	"./DSC_0070-1024x683.jpg": 2313,
	"./DSC_0071-1024x683.jpg": 7987,
	"./DSC_0078-1024x683.jpg": 3525,
	"./DSC_0082-1024x683.jpg": 2593,
	"./DSC_0084-1024x683.jpg": 403,
	"./DSC_0085-1024x683.jpg": 4745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 581;